module.exports = __webpack_public_path__ + "static/media/jacobs_hill-01.9b32a58c.png";